import React from "react";

export default React.createContext({
    google: null,
    setGoogle: () => {}
});
